export default {
  init(authBase) {
    const requestCall = authBase;
    return {
      fetchAccountData(requestPayload) {
        return requestCall.accountData(requestPayload);
      },
      submitExchange(requestPayload) {
        return requestCall.submitRecommendForm(requestPayload);
      }
    };
  }
};
